<template>
    <AppHeader fixed class="navbar navbar-dark bg-dark breadcumb-hidden">
      <!-- Navbar content -->
 <SidebarToggler class="d-lg-none" display="md" mobile />
   &nbsp;  &nbsp;  &nbsp;  &nbsp;  &nbsp;  &nbsp; <b-link class="navbar-brand" to="#">
        <img class="navbar-brand-full" src="img/brand/apple-icon-180x180.png" height="50" alt="PTTBS Logo">
       &nbsp;  &nbsp;  &nbsp; Tirta Bumi Sentosa</b-link>
     &nbsp;  &nbsp;  &nbsp;  &nbsp;  &nbsp;  &nbsp; 
    
      <SidebarToggler class="d-md-down-none" display="lg" :defaultOpen=true />
   <!--   <b-navbar-nav class="d-md-down-none">
        <b-nav-item class="px-3" to="/home">Home</b-nav-item>
        <b-nav-item class="px-3" to="/about">About</b-nav-item>
        <b-nav-item class="px-3" to="/products">Products</b-nav-item>
        <b-nav-item class="px-3">Industries</b-nav-item>
      </b-navbar-nav>
       --> <b-navbar-nav class="ml-auto">
      
      <!--  <DefaultHeaderDropdownAccnt/>-->
      </b-navbar-nav>
      <!--<AsideToggler class="d-lg-none" mobile />-->
      
      
   
    </AppHeader>
</template>
<script>
import { Header as AppHeader, SidebarToggler, AsideToggler } from '@coreui/vue'
import DefaultHeaderDropdownAccnt from './DefaultHeaderDropdownAccnt'

export default {
  name: 'DefaultHeader',
  components: {
    AsideToggler,
    AppHeader,
    DefaultHeaderDropdownAccnt,
    SidebarToggler
  }
}
</script>
